/* Dawn clears the "is-empty" state from .drawer__inner but not from the
   <cart-drawer> element itself. When the bag starts empty, the first item
   added is therefore rendered but collapsed to zero height. Keep the class
   in sync with what the drawer actually contains. */
(function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  function sync() {
    var hasItems = !!drawer.querySelector('.cart-item');
    drawer.classList.toggle('is-empty', !hasItems);
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.toggle('is-empty', !hasItems);
    var items = drawer.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('is-empty', !hasItems);
  }

  sync();
  new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
})();
